howspace.workspace.limit = (() => {
    'use strict';

    // The keys the server answers with when a workspace or template would take the organisation past its limit.
    const LIMIT_REACHED_KEYS = ['workspace_limit_reached', 'template_limit_reached'];

    // Reaching the limit is an expected refusal, not a bug. The user still sees its message, but it isn't logged.
    const isReached = response => LIMIT_REACHED_KEYS.some(key => real.ajax.hasErrorKey(response, key));

    return {
        isReached: isReached,
    };
})();
